var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current-frame",style:(_vm.currentFrame.style)},[(_vm.currentFrame.text)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.currentFrame.text)}}):_vm._e(),_c('ImageAttribution')],1)}
var staticRenderFns = []

export { render, staticRenderFns }